import React from 'react';
import { UTCtoTimeZone } from 'Utils/UTCConverter';
import { useGetDvTimeSeriesLogsMutation } from 'Services/api/reportsApi';
import { Pane, Table } from 'evergreen-ui';
import SuspenseSpinner from 'Utils/SuspenseSpinner';
import { VirtualList } from 'Utils/VirtualList';
import { DataValueTSFull, Log } from './types';

type HistoryChangesProps = {
  measurement: DataValueTSFull
  zone: string
}

export default function HistoryChanges({ measurement, zone }: HistoryChangesProps) {
  const [trigger, { data: tsLogs = [], isLoading: isLoadingLogs }] = useGetDvTimeSeriesLogsMutation();

  const TableRow = React.useCallback((log: Log) => (
    <Table.Row>
      <Table.TextCell>
        {log.dateTime ? `${UTCtoTimeZone(log.dateTime, zone)} UTC${zone}` : ''}
      </Table.TextCell>
      <Table.TextCell>
        {log.userName || '-'}
      </Table.TextCell>
      <Table.TextCell>
        {log.value}
      </Table.TextCell>
      <Table.TextCell>
        {log.qc}
      </Table.TextCell>
      <Table.TextCell title={log.dataValueComment?.comment || '-'}>
        {log.dataValueComment?.comment || '-'}
      </Table.TextCell>
      <Table.TextCell title={log.jsonParameters?.jsonParameters || '-'}>
        {log.jsonParameters?.jsonParameters || '-'}
      </Table.TextCell>
    </Table.Row>
  ), [zone]);

  React.useEffect(() => {
    if (measurement && !measurement.isNew) {
      trigger(measurement);
    }
  }, [measurement, trigger]);

  return (
    <Pane
      display="grid"
      gridTemplateRows="max-content 1fr"
      border
    >
      <Table>
        <Table.Head>
          <Table.TextHeaderCell>
            Время
          </Table.TextHeaderCell>
          <Table.TextHeaderCell>
            Пользователь
          </Table.TextHeaderCell>
          <Table.TextHeaderCell>
            Значение
          </Table.TextHeaderCell>
          <Table.TextHeaderCell>
            Флаг качества
          </Table.TextHeaderCell>
          <Table.TextHeaderCell>
            Комментарий
          </Table.TextHeaderCell>
          <Table.TextHeaderCell>
            Параметры
          </Table.TextHeaderCell>
        </Table.Head>
      </Table>
      <HistoryTableBody
        isFetching={isLoadingLogs}
        logs={tsLogs}
        TableRow={TableRow}
      />
    </Pane>
  );
}

type HistoryTableBodyProps = {
  isFetching: boolean
  logs: Log[]
  TableRow: (log: Log) => JSX.Element
}

function HistoryTableBody({ isFetching, logs = [], TableRow }: HistoryTableBodyProps) {
  if (isFetching) return <SuspenseSpinner />;
  if (logs.length === 0) return <Table.Row><Table.TextCell>Нет данных</Table.TextCell></Table.Row>;
  return <VirtualList data={logs} row={TableRow} />;
}
